import React from 'react';
import { Spinner } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes, ITagPreviewJson } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';

const TagPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: tag,
    loading,
    error,
  } = useObjectPreview<ITagPreviewJson>(id, INamedObjectTypes.Tag);
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;
  return (
    <div className="tag-preview">
      <style jsx>{`
        .tag-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
        }

        .tag-preview__thing-list > div {
          display: flex;
        }

        .tag-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      {tag && (
        <>
          <div className="tag-preview__banner">
            <h3 style={{ margin: '0 5px' }}>{tag.name}</h3>
          </div>
          <div className="tag-preview__body">
            <div className="tag-preview__thing-list">
              <div>
                <strong>Lookup</strong>
                <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/lookup/${id}`}>
                  {id}{' '}
                </IsomorphicLink>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TagPreview;
